import { render, staticRenderFns } from "./AppFileUploader.vue?vue&type=template&id=5976c5af&scoped=true&"
import script from "./AppFileUploader.vue?vue&type=script&lang=ts&"
export * from "./AppFileUploader.vue?vue&type=script&lang=ts&"
import style0 from "./AppFileUploader.vue?vue&type=style&index=0&id=5976c5af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5976c5af",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
